if (!customElements.get('seluna-compare')) {
    customElements.define('seluna-compare', class extends HTMLElement {
      connectedCallback() {
        // A second slider upgrades on its open tag, before its children parse; wait for them.
        if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => this.init(), { once: true });
        else this.init();
      }
      init() {
        if (this.ready) return;
        this.ready = true;
        const r = this.querySelector('input');
        const bi = this.querySelector('.seluna-cmp__before img');
        if (bi) { bi.dataset.aiBadged = '1'; bi.parentElement.querySelectorAll('.ai-badge').forEach((b) => b.remove()); }
        const set = (v) => { this.style.setProperty('--pos', v + '%'); r.value = v; };
        r.addEventListener('input', () => { this.stop(); set(r.value); });
        r.addEventListener('keydown', () => this.stop());
        const at = (e) => { const b = this.getBoundingClientRect(); set(Math.max(0, Math.min(100, ((e.clientX - b.left) / b.width) * 100)).toFixed(1)); };
        this.addEventListener('dragstart', (e) => e.preventDefault());
        let g = null;
        // A fast flick, or a drag that continues past an end of the slider, moves the gallery to the next or previous image.
        const turn = (dir) => { const s = this.closest('slideshow-component'); if (s) (dir > 0 ? s.next() : s.previous()); };
        this.addEventListener('pointerdown', (e) => {
          e.stopPropagation(); if (e.pointerType === 'mouse') e.preventDefault(); this.stop(); this.drag = true; this.setPointerCapture(e.pointerId);
          const pos = parseFloat(r.value);
          g = { x: e.clientX, y: e.clientY, t: e.timeStamp, edge: pos <= 2 ? -1 : pos >= 98 ? 1 : 0 };
          at(e);
        });
        this.addEventListener('pointermove', (e) => { if (this.drag) at(e); });
        this.addEventListener('pointerup', (e) => {
          this.drag = false;
          if (!g || e.pointerType === 'mouse') return;
          const dx = e.clientX - g.x, dy = e.clientY - g.y, dir = Math.sign(dx);
          const flick = Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy) && Math.abs(dx) / Math.max(1, e.timeStamp - g.t) > 0.5;
          const pastEnd = g.edge !== 0 && dir === g.edge && Math.abs(dx) > 30 && Math.abs(dx) > Math.abs(dy);
          g = null;
          if (flick || pastEnd) turn(-dir);
        });
        this.addEventListener('pointercancel', () => { this.drag = false; g = null; });
        if (matchMedia('(prefers-reduced-motion: reduce)').matches) return;
        new IntersectionObserver(([e], o) => {
          if (!e.isIntersecting) return;
          o.disconnect();
          const t0 = performance.now();
          const tick = (t) => {
            if (this.stopped) return;
            set((50 - 35 * Math.sin((t - t0) / 1400)).toFixed(1));
            this.raf = requestAnimationFrame(tick);
          };
          this.raf = requestAnimationFrame(tick);
        }, { threshold: 0.4 }).observe(this);
      }
      stop() { this.stopped = true; cancelAnimationFrame(this.raf); }
    });
  }
